var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-container",style:('--padding:' + _vm.padding + 'px')},[(_vm.$slots.header)?_c('div',{ref:"header",staticClass:"header"},[_vm._t("header")],2):_vm._e(),_c('el-scrollbar',[_vm._t("default")],2),(_vm.$slots.footer)?_c('div',{ref:"footer",staticClass:"footer"},[_vm._t("footer")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }